import { Space } from 'antd';
import { DocumentoSenzaAzioni } from 'client/api/backend/schemas';
import { getAnchorId } from 'client/ui/anchor/getAnchorId';
import { ActionsContainer } from 'client/ui/card/container/ActionsContainer';
import { TaskCard, TaskCardMode } from 'client/ui/card/TaskCard';
import React from 'react';
import { ProcedureAttachmentGroupSection } from '../attachment/ProcedureAttachmentGroupSection';
import { ProcedureDeclarationSection } from '../declarations/ProcedureDeclarationSection';
import { ProcedureDocumentActButton } from './actions/ProcedureDocumentActButton';
import { ProcedureDocumentOmissisButton } from './actions/ProcedureDocumentOmissisButton';
import { ProcedureDocumentProposalButton } from './actions/ProcedureDocumentProposalButton';

export interface IProcedureDocumentSectionProps {
  document: DocumentoSenzaAzioni;
  procedureId: string;
}

export function ProcedureDocumentSection(
  props: IProcedureDocumentSectionProps
) {
  const { document, procedureId } = props;

  // Id del file più recente del documento
  const documentFileId = document.files?.find(
    f => f.progressivo === Math.max(...document.files!.map(f => f.progressivo!))
  )?.idFile;

  return (
    <TaskCard
      id={getAnchorId(document.idTipoDocumento!)}
      mode={TaskCardMode.Document}
      title={document.nomeTipoDocumento}
    >
      <ActionsContainer
        right={
          <Space direction="horizontal" size="small">
            <ProcedureDocumentProposalButton
              procedureId={procedureId}
              documentId={document.idDocumento}
            />
            <ProcedureDocumentOmissisButton
              procedureId={procedureId}
              documentId={document.idDocumento}
            />
            <ProcedureDocumentActButton
              procedureId={procedureId}
              documentId={document.idDocumento}
            />
          </Space>
        }
        left={<></>}
      />

      {/* Sezione Dichiarazione */}
      {document.dichiarazioni?.map((declaration, index) => (
        <ProcedureDeclarationSection declaration={declaration} key={index} />
      ))}

      {/*  Sezione Gruppo allegati */}
      {document.gruppoAllegati?.map((group, index) => (
        <ProcedureAttachmentGroupSection
          group={group}
          key={index}
          procedureId={procedureId}
        />
      ))}
    </TaskCard>
  );
}
